import { FC } from 'react';
import { IVariant } from 'base/interfaces/product';
import { LoopRender } from '@base/snippets/LoopRender';

type IProps = {
    variant: IVariant;
    className?: string;
};

export const ProdTechnicalSpecs: FC<IProps> = ({ variant, className }) => {
    const list = variant.productAttributeList


    return !list?.length ? null : (
        <div className={className}>
            <table>
                <LoopRender
                    tag={'tbody'}
                    list={list}
                    render={item => (
                        <tr>
                            <th className={'g-label'}>
                                {item.attributeOptionName}
                            </th>
                            <LoopRender
                                className={'g-value'}
                                tag={'td'}
                                list={item?.attributeValues}
                                render={vItem => (
                                    <p>{vItem.name}</p>
                                )}
                            />
                        </tr>
                    )}
                />
            </table>
        </div>
    )
};
